import { useCallback, useEffect, useRef, useState } from "react"


export function PageTest() {

  const [isBtnActive, setBtnActive] = useState<boolean>(false)

  const canvasRef = useRef<HTMLCanvasElement>(null)

  useEffect(() => {
    document.title = 'test'
  }, [])

  // 点击 btn-me 时，根据 isBtnActive 状态在 canvas 上绘制圆形
  // useEffect(() => {
  //   const canvas = canvasRef.current
  //   if (!canvas) return
  //   const ctx = canvas.getContext('2d')
  //   if (!ctx) return

  //   ctx.clearRect(0, 0, canvas.width, canvas.height)
  //   const cx = canvas.width / 2
  //   const cy = canvas.height / 2
  //   const radius = isBtnActive ? 120 : 60
  //   ctx.beginPath()
  //   ctx.arc(cx, cy, radius, 0, Math.PI * 2)
  //   ctx.fillStyle = isBtnActive ? '#667eea' : '#22c55e'
  //   ctx.fill()
  // }, [isBtnActive])

  const drawCircle = useCallback((isBtnActive: boolean) => {
    const canvas = canvasRef.current
    if (!canvas) return
    const ctx = canvas.getContext('2d')
    if (!ctx) return

    ctx.clearRect(0, 0, canvas.width, canvas.height)
    const cx = canvas.width / 2
    const cy = canvas.height / 2
    const radius = isBtnActive ? 120 : 60
    ctx.beginPath()
    ctx.arc(cx, cy, radius, 0, Math.PI * 2)
    ctx.fillStyle = isBtnActive ? '#667eea' : '#22c55e'
    ctx.fill()



  }, [])

  // 导出 canvas 为图片并下载
  const exportImage = useCallback(() => {
    const canvas = canvasRef.current
    if (!canvas) return
    const url = canvas.toDataURL('image/png')
    const a = document.createElement('a')
    a.href = url
    a.download = `circle-${isBtnActive ? 'active' : 'normal'}.png`
    a.click()
  }, [isBtnActive])

  return (
    <div className="flex flex-col w-full h-full bg-red-300 justify-center items-center">
      <div className=" flex flex-col w-40 h-40 bg-yellow-200">
        <div className={`btn-me ${isBtnActive ? 'translate-y-6' : ''} bg-blue-500 active:bg-indigo-800 hover:bg-amber-800 cursor-pointer transition-transform duration-300`} onClick={() => {
          setBtnActive(!isBtnActive)
          drawCircle(!isBtnActive)
        }}
        >
          {'您好，点我'}
        </div>
      </div>
      <canvas ref={canvasRef} width={320} height={320} className="w-80 h-80" />
      <button
        className="mt-4 px-4 py-2 rounded bg-gray-800 text-white cursor-pointer"
        onClick={exportImage}
      >
        导出图片
      </button>
    </div>
  )
}